package com.bulut.mecitogullari.navigation

import androidx.navigation3.runtime.NavKey
import kotlinx.serialization.Serializable

/**
 * Navigation 3 route keys. Data passed between screens travels as
 * constructor arguments of these keys.
 */

@Serializable
data object LoginRoute : NavKey

// Bottom navigation tabs
@Serializable
data object DashboardRoute : NavKey

@Serializable
data object TransactionsRoute : NavKey

@Serializable
data object ProjectsRoute : NavKey

@Serializable
data object DebtsRoute : NavKey

@Serializable
data object ReportsRoute : NavKey

@Serializable
data object ProfileRoute : NavKey

// Pushed screens
/** [transactionId] is empty for a new entry, otherwise the entry to edit. */
@Serializable
data class AddTransactionRoute(val transactionId: String = "") : NavKey

@Serializable
data object NewProjectRoute : NavKey

@Serializable
data class ProjectDetailRoute(val projectId: String) : NavKey

@Serializable
data class SupplierDetailRoute(val supplierId: String) : NavKey

@Serializable
data object CraftsmenRoute : NavKey

@Serializable
data class CraftsmanDetailRoute(val craftsmanId: String) : NavKey

/** [entryId] is empty for a new purchase, otherwise the entry to edit. */
@Serializable
data class PurchaseRoute(val supplierId: String, val entryId: String = "") : NavKey
